import { useContext, useEffect, useState } from 'react';
import { Button, ButtonGroup } from '@upmc/ims.component-library';
import Base from '../../../Base/Base';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import Modal from '@mui/material/Modal';
import MaterialIcon from '@material/react-material-icon';
import { Checkbox } from '@upmc/ims.component-library';
import {
	Subtitle2,
	Subtitle1,
	Headline5,
	Body2,
} from '../../../../components/UI/MDC/Typography/Typography';
import { Actions } from '../../../../components/UI/MDC/Card/Card';
import Switch from '@material/react-switch';
import StyleAuxiliary from '../../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import { DataTable } from '../../../../components/UI/MDC/DataTable/DataTable';
import { AssignWorkQueueRequests } from './RequestsTable_api';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton } from '@upmc/ims.component-library';
import {
	init,
	setRows,
	toggleRow,
	toggleRows,
	sortByHeader,
	indexRows,
	filterRows,
} from '../../../../store/workQueue/actions';
import { ACTION_FILTER_TYPES } from '../../../../store/workQueue/_actionTypes';
import {
	fetchWorkQueue,
	approveAllRequestsSelected,
} from '../WorkQueue/WorkQueueResults_api';
import { HEADERS, HeaderDataCorrelation } from '../WorkQueue/_constants';
import { generateRowData } from '../WorkQueue/_utility';
import { ACTION_TYPES } from '../../../../components/UI/MDC/DataTable/_types';
import { nanoid } from 'nanoid';
import { deepCloneObject } from '../../../../store/utility';
import { getLegacyPath } from 'routes/_utils';
import { UserContext } from 'context/User/UserContext';
import classes from './RequestsTable.module.scss';
import { APP_IDENTIFIER_TYPES } from '../WorkQueue/_utility';
import Icon from '../../../../components/UI/MDC/Icon/Icon';
import { debounce } from '../../../../utils/misc/debounce';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';

/**
 * Wrapping component for Work Queue Page
 *
 * @returns rendered component.
 */
const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: '#771b61',
		color: theme.palette.common.white,
		whiteSpace: 'nowrap',
		width: '1%',
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14,
	},
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)': {
		backgroundColor: theme.palette.action.hover,
	},
	'&:hover': {
		backgroundColor: theme.palette.action.selected,
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0,
	},
}));
const RequestsTable = ({
	currentSystem,
	admin,
	handleLoadingState,
	GetWorkQueueAdmins,
}) => {
	//#region REDUX STORE VARIABLES
	// const rActions = useSelector(state => state.workQueueAdminTable.actions);
	const rRows = useSelector(state => state.workQueueAdminTable.rows);

	const rHeadersAdminWQ = useSelector(state => state.workQueue.headers);
	const rActionsAdminWQ = useSelector(state => state.workQueue.actions);
	const workQueueRows = useSelector(state => state.workQueue.rows);
	//#endregion REDUX STORE VARIABLES

	const dispatch = useDispatch();
	/**
	 * @type {import('context/User/UserContext').ContextUser}
	 */
	const contextUser = useContext(UserContext);
	const user =
		contextUser.userInfo.impersonationProfile ??
		contextUser.userInfo.userProfile;

	const [rRowsAdminWQ, setrRowsAdminWQ] = useState([]);
	const history = useHistory();

	useEffect(() => {
		setrRowsAdminWQ(workQueueRows.filter(row => row.isDisplayed === true));
	}, [workQueueRows]);

	const [openModal, setOpenModal] = useState(false);
	const [openAssignModal, setOpenAssignModal] = useState(false);
	const [RPModal, setOpenRPModal] = useState(false);
	const [pending, setPending] = useState(false);
	const [nonActionable, setNonActionable] = useState(false);
	const [saving, setSaving] = useState(false);
	const [loading, setLoading] = useState(true);
	const [completeError, setCompleteError] = useState(null);
	const [showUnassignedOnly, setShowUnassignedOnly] = useState(false);
	const [quantitySelected, setQuantitySelected] = useState(0);
	const [quantityForBulkComplete, setQuantityForBulkComplete] = useState(0);
	const [assignee, setAssignee] = useState(null);
	const [refreshDate, setRefreshDate] = useState(new Date().toLocaleString());
	const [searchValue, setSearchValue] = useState(null);
	const [unactionableSelectedApps, setUnactionableSelectedApps] = useState();

	useEffect(() => {
		if (RPModal === false) {
			GetAllWorkQueueRequests();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [RPModal]);

	const [fetchWorkQueueAPIRequest, setFetchWorkQueueAPIRequest] = useState({
		ID: -1,
		Pending: false,
		TrackingNumber: null,
		AppId: null,
		RequesteeFirst: null,
		RequesteeLast: null,
		RequesteeNetworkID: null,
		RequestorNetworkID: null,
		range: -1,
		systemID: -1,
		nonActionable: false,
	});

	useEffect(() => {
		const selectedRows = workQueueRows.filter(
			row => row.ActionCells[0].Checked === true,
		);

		setUnactionableSelectedApps(
			selectedRows.filter(application => {
				const pendingValue = application.Cells['Pending']?.Value;
				const unactionableValue =
					application.Cells['Unactionable']?.Value;

				return (
					(pendingValue && pendingValue !== '') ||
					(unactionableValue && unactionableValue !== '')
				);
			}),
		);
	}, [workQueueRows]);

	/**
	 * Click handler for showing unassigned requests only checkbox
	 *
	 * @returns void
	 */
	const handleCheckBoxClick = e => {
		if (e.target.checked) {
			setShowUnassignedOnly(true);
		} else {
			setShowUnassignedOnly(false);
		}
	};

	const [applicationType, setApplicationType] = useState('All');

	useEffect(() => {
		if (handleLoadingState) {
			handleLoadingState(loading);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loading]);

	useEffect(() => {
		if (rRows.length > 0) {
			setAssignee(rRows[0]);
		}
	}, [rRows]);

	useEffect(() => {
		GetAllWorkQueueRequests();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pending, nonActionable]);

	// Select either impersonation profile or user profile
	// Set the ID for fetchWorkQueueAPIRequest with the profile ID
	useEffect(() => {
		setPending(false);
		setNonActionable(false);
		GetAllWorkQueueRequests();
		setShowUnassignedOnly(false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentSystem, user]);

	// Filter by unassigned only
	useEffect(() => {
		if (rRowsAdminWQ.length) {
			if (showUnassignedOnly) {
				dispatch(
					filterRows({
						filterType: ACTION_FILTER_TYPES.QUEUE_FILTER_UNASSIGNED,
						filter: 'Unassigned',
					}),
				);
			} else {
				dispatch(
					filterRows({
						filterType: ACTION_FILTER_TYPES.QUEUE_FILTER_UNASSIGNED,
						filter: null,
					}),
				);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showUnassignedOnly]);

	// Context Menu Logic BEGIN
	const [contextMenu, setContextMenu] = useState({
		visible: false,
		x: 0,
		y: 0,
		data: null,
	});

	const handleRightClick = (rowData, event) => {
		event.preventDefault(); // Prevents the default context menu from showing up

		const rect = event.target.getBoundingClientRect();

		setContextMenu({
			visible: true,
			x: rect.left,
			y: rect.top,
			data: rowData,
		});
	};

	const handleOpenInNewTab = () => {
		let queueIDs = contextMenu?.data?.Cells['WorkQueueID'].Value.split(
			',',
		).map(appID => appID.toString());

		let rowLink = `/workqueue/RequestProcessing.aspx?tn=${contextMenu?.data?.Cells['Tracking Number'].Value}&appID=${queueIDs[0]}`;

		let link = getLegacyPath(rowLink);
		window.open(window.location.origin + link, '_blank');

		handleClose();
	};

	const handleClose = () => {
		setContextMenu({ visible: false, x: 0, y: 0, data: null });
	};

	useEffect(() => {
		// function to hide menu
		const hideMenu = e => {
			setTimeout(() => {
				setContextMenu({ visible: false, x: 0, y: 0, data: null });
			}, 1000); // delay of 1 second
		};

		// function to handle keydown
		const handleKeydown = e => {
			if (e.key === 'Escape') {
				hideMenu();
			}
		};

		const handleMouseDown = e => {
			// Check if click is outside the context menu
			if (contextMenu.visible && e.target.closest('.menu') === null) {
				hideMenu();
			}
		};

		// add the listeners
		document.addEventListener('mousedown', handleMouseDown);
		document.addEventListener('keydown', handleKeydown);

		// remove the listeners when the component is unmounted
		return () => {
			document.removeEventListener('mousedown', handleMouseDown);
			document.removeEventListener('keydown', handleKeydown);
		};
	}, [contextMenu]);
	// Context Menu Logic END

	/**
	 * Completes all the selected requests
	 *
	 * @returns void
	 */
	const CompleteAllSelected = () => {
		setSaving(true);
		var argsAPI = {
			T_ESO_FI_ID: user.ID,
			RequestList: [],
		};
		rRowsAdminWQ
			.filter(row => row.ActionCells[0].Checked === true)
			.map((row, index) => {
				// Generated csv wth app IDs
				let appIDs = row.Cells.ApplicationID.Value.split(',').map(
					appID => appID.toString(),
				);

				// Generated csv wth app names
				let appNames = row.Cells.Application.Value.split(',').map(
					appID => appID.toString(),
				);

				// Generated csv wth work queue names
				let queueNames = row.Cells['Queue Name'].Value.split(',').map(
					appID => appID.toString(),
				);

				// Generated csv with usernames
				let usernames = row.Cells['Username'].Value.split(',').map(
					username => username.trim(),
				);

				// Use that appIDs index and create the application object while adding the other associated values to the object
				return appIDs.forEach((appID, genericIndex) => {
					if (
						row.Cells['Pending'].Value === '' &&
						row.Cells['Unactionable'].Value === ''
					) {
						return argsAPI.RequestList.push({
							TrackingNumber: row.Cells['Tracking Number'].Value,
							Application: {
								ID: appID,
								Name: appNames[genericIndex],
								WorkQueueName: queueNames[genericIndex],
								WorkQueueID: row.Cells['WorkQueueID'].Value,
								Username: usernames[genericIndex],
							},
							// TODO: Keep because in next release we will use this logic instead once we make API more efficient
							// Action: row.Cells['ActionsAvailable'].Value.find(
							// 	action => action.F_Short === 'Completed'
							// ),
							Action: {
								FI_ID: 0,
								F_Status_Id: 1,
								F_Short: '',
								F_System_Id: 0,
							},
							AcctAdminComments: '',
							RequestAdjustmentComments: '',
							InternalComments: '',
						});
					} else {
						return null;
					}
				});
			});
		approveAllRequestsSelected(argsAPI).then(resp => {
			if (resp?.data?.payload?.ApprovedAllRequests) {
				GetAllWorkQueueRequests();
				GetWorkQueueAdmins?.();
				setOpenModal(false);
			} else {
				setCompleteError(resp?.error);
			}
			setSaving(false);
		});
	};

	/**
	 * Sets number of selected requests to state variable
	 *
	 * @returns void
	 */
	const getSelectedQuantity = () => {
		setQuantityForBulkComplete(
			rRowsAdminWQ.filter(
				row =>
					row.ActionCells[0].Checked === true &&
					row.Cells['Pending'].Value === '' &&
					row.Cells['Unactionable'].Value === '',
			).length,
		);
		setQuantitySelected(
			rRowsAdminWQ.filter(row => row.ActionCells[0].Checked === true)
				.length,
		);
	};

	// Get the quantity of rows selected if the rows data change
	useEffect(() => {
		getSelectedQuantity();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [rRowsAdminWQ]);

	// Initial render configure the Redux store for requests table
	useEffect(() => {
		dispatch(
			init({
				actions: [
					{
						Type: ACTION_TYPES.CHECKBOX,
						onChangedHandler: (_, __, row) => {
							dispatch(toggleRow(row));
						},
						Header: {
							Checked: false,
							Key: '0',
							onChangedHandler: e => dispatch(toggleRows(e, 0)),
						},
					},
					{
						Type: ACTION_TYPES.FLAG_PROBLEM,
						onChangedHandler: (_, __, row) => {
							// dispatch(toggleRow(row));
						},
						Header: {
							Checked: false,
							Key: '0',
							onChangedHandler: e => dispatch(toggleRows(e, 0)),
						},
					},
					{
						Type: ACTION_TYPES.FLAG_LOCK,
						onChangedHandler: (_, __, row) => {
							// dispatch(toggleRow(row));
						},
						Header: {
							Checked: false,
							Key: '0',
							onChangedHandler: e => dispatch(toggleRows(e, 0)),
						},
					},
				],
				headers: Object.entries(HEADERS).map(([key, val], index) => {
					return {
						Value: val,
						props: {
							onSortChange: sortOrder =>
								dispatch(sortByHeader(val, sortOrder)),
							sort: index === 0 ? 1 : null,
							alignMiddle: true,
						},
					};
				}),
			}),
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	/**
	 * OnClick handler for rows if they have an action as well
	 *
	 * @returns void
	 */
	const RowOnClickHandler = async row => {
		// KEEP this commented out for now because might need to revert to this method if modal is not liked
		// window.top.location.href = `/${determineIfExternal(
		// 	`/workqueue/RequestProcessing.aspx?tn=${row.Cells['Tracking Number'].Value}&appID=${currentSystem.ID}`
		// )}`;

		// Open modal with Request Processing page
		setOpenRPModal(true);

		history.push({
			pathname: `/workqueue/Request`,
			search: `?TrackingNumber=${
				row.Cells['Tracking Number'].Value
			}&SystemName=${
				row.Cells['Queue Name']?.Value?.split(',')[0]
			}&SystemID=${row.Cells['WorkQueueID']?.Value?.split(',')[0]}`,
			state: {
				appIDs: row.Cells['ApplicationID'].Value.split(',').map(Number),
				itemIDs: row.Cells['ItemID'].Value.split(',').map(Number),
				row: row,
			},
		});
	};

	/**
	 * Gets all work queue requests and generates the row data for the datatable component
	 *
	 * @returns void
	 */
	const GetAllWorkQueueRequests = () => {
		setShowUnassignedOnly(false);
		if (user?.ID) {
			if (currentSystem !== null) {
				let tempFetchRequest = deepCloneObject(
					fetchWorkQueueAPIRequest,
				);
				tempFetchRequest.Pending = pending;
				tempFetchRequest.systemID = currentSystem.ID;
				tempFetchRequest.ID = user.ID;
				tempFetchRequest.nonActionable = nonActionable;
				setFetchWorkQueueAPIRequest({
					...fetchWorkQueueAPIRequest,
					Pending: pending,
					systemID: currentSystem.ID,
					ID: user.ID,
					nonActionable: nonActionable,
				});

				if (tempFetchRequest.ID !== null) {
					setLoading(true);
					fetchWorkQueue(tempFetchRequest).then(resp => {
						var data = resp?.data?.payload;

						// Generate row data for the work queue table
						var rows = generateRowData(
							data.Requests,
							HeaderDataCorrelation,
						);

						var newRows = rows.map(row => {
							let newRow = deepCloneObject(row);

							// Let the Tracking Number column
							Object.keys(newRow.Cells).map(key => {
								if (key !== HEADERS.TrackingNumber) {
									newRow.Cells[key].props = {
										onClick: () => RowOnClickHandler(row),
										alignMiddle: true,
										// breakText: true,
									};
								}

								// Break up the action and application
								if (
									key === HEADERS.Action ||
									key === HEADERS.Application
								) {
									newRow.Cells[key].props = {
										...newRow.Cells[key].props,
										breakText: true,
									};
								}

								// Add extendText component to tracking number cells
								// Also add cellTextOnClick which allows the extendText component to first expand the text,
								// then allow it to behave like the rest of the rows and be clickable to show RequestProcessing page
								if (key === HEADERS.TrackingNumber) {
									newRow.Cells[key].props = {
										...newRow.Cells[key].props,
										// extendtext: 10,
										alignMiddle: true,
										cellTextOnClick: () =>
											RowOnClickHandler(row),
									};
								}
								return true;
							});
							return newRow;
						});

						dispatch(
							setRows(
								newRows.map(item => {
									var newItem = deepCloneObject(item);

									// Add pending action
									if (item.Cells.Pending.Value !== '') {
										newItem.ActionCells[1] = {
											BindTo: 2,
											Checked: false,
											Key: nanoid(),
											Text: item.Cells.Pending.Value,
											Type: ACTION_TYPES.FLAG_PROBLEM,
										};
									} else if (
										item.Cells.Unactionable.Value !== ''
									) {
										if (
											item.Cells.Unactionable.Value ===
											'There is a non-actionable event on this request.'
										) {
											newItem.ActionCells[1] = {
												BindTo: 1,
												Checked: false,
												Key: nanoid(),
												Text: item.Cells.Unactionable
													.Value,
												Type: ACTION_TYPES.FLAG_LOCK,
											};
										}
									}

									return newItem;
								}),
							),
						);
						setLoading(false);
						setRefreshDate(new Date().toLocaleString());
						setSearchValue('');
					});
				}
			}
		}
	};

	/**
	 * Assigns requests to another admin selected
	 *
	 * @returns void
	 */
	const AssignRequests = () => {
		var api_args = {
			systemID: currentSystem?.ID,
			currentUser_ESO_ID: user?.ESOID,
			assignee_FI_ID: assignee?.Cells['FI_ID'].Value,
			requests: null,
		};

		var checkedRows = rRowsAdminWQ.filter(
			row => row.ActionCells[0].Checked === true,
		);
		api_args.requests = [
			...checkedRows.map(x => {
				return {
					Name: x.Cells['Tracking Number'].Value,
					ID: x.Cells['ItemID'].Value,
				};
			}),
		];
		setSaving(true);
		AssignWorkQueueRequests(api_args).then(resp => {
			if (resp.data.payload) {
				GetAllWorkQueueRequests();
				GetWorkQueueAdmins?.();
				setSaving(false);
				setOpenAssignModal(false);
			}
		});
	};
	return (
		<>
			<Modal
				open={openAssignModal}
				onClose={() => setOpenAssignModal(false)}
			>
				<div className={classes.Modal}>
					<Base title='Assign Work Queue Requests'>
						<StyleAuxiliary classes={classes.controls}>
							<Subtitle1>
								You will be assigning all{' '}
								<b>{quantitySelected}</b> selected requests to:
							</Subtitle1>
							<FormControl>
								<InputLabel id='admin-selector--work-queue-selector'>
									Work Queue Admin
								</InputLabel>
								<Select
									className={
										classes['select--applications--default']
									}
									id='work-queue__select--workqueue-admin'
									label='Work Queue Admin'
									value={
										assignee?.Cells
											? assignee?.Cells['Account Admin']
													?.Value
											: assignee
									}
									onChange={e => {
										setAssignee(
											...rRows.filter(
												x =>
													x.Cells['Account Admin']
														.Value ===
													e.target.value,
											),
										);
									}}
								>
									{Object.values(
										rRows?.map(
											x => x.Cells['Account Admin'].Value,
										),
									).map(e => (
										<MenuItem value={e}>{e}</MenuItem>
									))}
								</Select>
							</FormControl>
							<Actions>
								<ButtonGroup
									className={classes['btn--cancel--default']}
								>
									<Button
										variant='outlined'
										startIcon={
											<MaterialIcon icon='cancel' />
										}
										onClick={() =>
											setOpenAssignModal(false)
										}
										id='FavUpdateCancel-Top'
									>
										Cancel
									</Button>
									<Button
										disabled={
											assignee ===
												'Please Select An Admin' ||
											saving
										}
										endIcon={
											saving ? (
												<CircularProgress size={24} />
											) : (
												<MaterialIcon icon='save' />
											)
										}
										color='primary'
										onClick={() => {
											AssignRequests();
										}}
										id='FavUpdateSave-Top'
									>
										{`${saving ? 'Saving' : 'Save'}`}
									</Button>
								</ButtonGroup>
							</Actions>
						</StyleAuxiliary>
					</Base>
				</div>
			</Modal>

			<Modal open={openModal} onClose={() => setOpenModal(false)}>
				<div className={classes.Modal}>
					<Base title='Bulk Complete Requests'>
						<StyleAuxiliary classes={classes.controls}>
							<Headline5>Are you sure?</Headline5>
							<Subtitle1>
								Performing this action will <b>bulk complete</b>{' '}
								<b>{quantityForBulkComplete}</b>/
								<b>{quantitySelected}</b> request(s) selected{' '}
								<b>without</b> comments.
								<br />
								{quantitySelected !==
								quantityForBulkComplete ? (
									<>
										<b>
											{quantitySelected -
												quantityForBulkComplete}
										</b>
										/<b>{quantitySelected}</b> are not
										available for bulk completion due to
										pending or unactionable status.
									</>
								) : null}
							</Subtitle1>
							{unactionableSelectedApps?.length > 0 && (
								<TableContainer>
									<Subtitle1
										className={
											classes['subtitle1--title--center']
										}
									>
										<b>Applications not bulk completing:</b>
									</Subtitle1>
									<Table>
										<TableHead>
											<StyledTableRow>
												<StyledTableCell>
													Tracking Number
												</StyledTableCell>
												<StyledTableCell>
													Unactionable
												</StyledTableCell>
												<StyledTableCell>
													Pending
												</StyledTableCell>
											</StyledTableRow>
										</TableHead>
										<TableBody>
											{unactionableSelectedApps.length >
												0 &&
												unactionableSelectedApps?.map(
													(application, index) => {
														const pendingValue =
															application.Cells[
																'Pending'
															]?.Value || '--';
														const unactionableValue =
															application.Cells[
																'Unactionable'
															]?.Value || '--';
														const trackingNumber =
															application.Cells[
																'Tracking Number'
															]?.Value || '--';

														return (
															<StyledTableRow
																key={index}
															>
																<StyledTableCell>
																	{
																		trackingNumber
																	}
																</StyledTableCell>
																<StyledTableCell>
																	{
																		unactionableValue
																	}
																</StyledTableCell>
																<StyledTableCell>
																	{
																		pendingValue
																	}
																</StyledTableCell>
															</StyledTableRow>
														);
													},
												)}
										</TableBody>
									</Table>
								</TableContainer>
							)}
							<Subtitle2
								className={
									classes['subtitle2--warning--default']
								}
							>
								** If this is <b>not</b> the desired intention,
								please cancel and process each request
								individually **
							</Subtitle2>
							<Actions>
								<ButtonGroup
									className={classes['btn--cancel--default']}
								>
									<Button
										variant='outlined'
										startIcon={
											<MaterialIcon icon='cancel' />
										}
										onClick={() => {
											setOpenModal(false);
											setCompleteError(null);
										}}
										id='FavUpdateCancel-Top'
									>
										Cancel
									</Button>
									<Button
										disabled={
											saving ||
											quantityForBulkComplete === 0
										}
										startIcon={
											saving ? (
												<CircularProgress size={24} />
											) : (
												<MaterialIcon icon='save' />
											)
										}
										color='primary'
										onClick={() => {
											CompleteAllSelected();
										}}
										id='FavUpdateSave-Top'
									>
										{`${
											saving ? 'Completing' : 'Complete'
										}`}
									</Button>
								</ButtonGroup>
							</Actions>
							{completeError ? (
								<Body2
									className={
										classes['error--message--default']
									}
								>
									{completeError}. Please cancel and complete
									manually.
								</Body2>
							) : null}
						</StyleAuxiliary>
					</Base>
				</div>
			</Modal>

			<Grid
				container
				direction='column'
				spacing={3}
				sx={{ alignItems: 'center' }}
			>
				<Grid item>
					{Object.values(APP_IDENTIFIER_TYPES).length > 2 && (
						<FormControl>
							<InputLabel id='work-queue__input--application-type'>
								Application Filter
							</InputLabel>
							<Select
								className={
									classes['select--applications--default']
								}
								id='work-queue__select--application-type'
								label='Application Filter'
								options={Object.values(APP_IDENTIFIER_TYPES)}
								value={applicationType}
								onChange={e => {
									setApplicationType(e.target.value);
									dispatch(
										filterRows({
											filterType:
												ACTION_FILTER_TYPES.QUEUE_FILTER_APPLICATION,
											application: e.target.value,
										}),
									);
								}}
							>
								{Object.values(APP_IDENTIFIER_TYPES).map(e => (
									<MenuItem value={e}>{e}</MenuItem>
								))}
							</Select>
						</FormControl>
					)}
					{admin && (
						<Subtitle2>
							<Checkbox
								disabled={loading}
								checked={showUnassignedOnly}
								onChange={e => handleCheckBoxClick(e)}
								label={'Show Only Unassigned Requests'}
							/>
						</Subtitle2>
					)}

					<Subtitle2>
						<Switch
							className={classes.switch}
							disabled={loading}
							id={'work-queue__switch--pending-applications'}
							onChange={() => setPending(!pending)}
							checked={pending}
						/>
						Include Pending and Non-actionable Applications
					</Subtitle2>
					<DataTable
						onContextMenu={() => {}}
						{...{ handleRightClick }}
						searchfieldText='Search...'
						resetSearchValue={searchValue}
						{...{ loading }}
						id={'work-queue__table--work-queue-list'}
						headers={rHeadersAdminWQ}
						actions={rActionsAdminWQ}
						rows={rRowsAdminWQ}
						indexed={true}
						infiniteScroll={true}
						pageSize={25}
						indexedHelperText={
							'Search via any table header data, including Tracking Number and Work Queue Name'
						}
						onTextFieldChangedHandler={e => {
							setSearchValue(e.target.value);
							dispatch(indexRows(e.target.value));
						}}
					/>
				</Grid>
				<Grid
					item
					sx={{
						top: contextMenu.y,
						left: contextMenu.x,
						position: 'fixed',
					}}
				>
					{contextMenu.visible && (
						<ul className={classes.menu}>
							<li
								className={classes.share}
								onClick={handleOpenInNewTab}
							>
								<IconButton id={`open_in_new${nanoid()}`}>
									<Icon
										fontSize={'10px'}
										icon='open_in_new'
									/>
								</IconButton>
								Open in new tab
							</li>
						</ul>
					)}
				</Grid>
				<Grid container direction='row' justifyContent='space-between'>
					<Grid
						item
						className={classes['grid-item--bulk-action--default']}
						sx={{ padding: '20px' }}
					>
						<Subtitle2>
							<b>
								{quantitySelected}/
								{
									rRowsAdminWQ.filter(
										row => row.isDisplayed === true,
									).length
								}
							</b>
							{' rows selected'}
						</Subtitle2>
						{admin && (
							<Button
								id={'work-queue__button--assign-all-action'}
								aria-describedby={
									'simple-button-assign-all-action'
								}
								className={classes['button--margin--right']}
								disabled={quantitySelected < 1}
								onClick={e => {
									setOpenAssignModal(true);
								}}
								color='primary'
								raised
							>
								Assign Selected Requests
							</Button>
						)}
						<Button
							className={classes['btn--bulk-action--default']}
							id={'work-queue__button--bulk-action'}
							aria-describedby={'simple-button-bulk-action'}
							color='primary'
							disabled={quantitySelected < 1}
							onClick={e => {
								setOpenModal(true);
							}}
							raised
						>
							Bulk Complete Selected Requests
						</Button>
					</Grid>
					<Grid item>
						<IconButton
							className={classes['icon--refresh--default']}
							onClick={debounce(GetAllWorkQueueRequests)}
							id={`refresh_icon${nanoid()}`}
						>
							<Icon icon='refresh' />
						</IconButton>
						<Subtitle2
							className={classes['subTitle--refresh--default']}
						>
							<b>Last Refreshed: </b>
							{refreshDate}
						</Subtitle2>
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};

export default RequestsTable;
